import {
  useParams,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import useAuth from "../../Hooks/useAuth";
import { axiosApi } from "../../Api/Axios";
import SubmitLoader from "../SubmitLoader";

const LoginPortalViaMyServiceTas = () => {
  let { tokenId } = useParams();
  const { auth, setAuth } = useAuth();
  const [errMsg, setErrMsg] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const hasRun = useRef(false);

  const callConnection = async () => {
    // console.log('Request call!');
    try {
        // Token is now a GUID (tokenId) that doesn't need encoding
        const response = await axiosApi.get(
          "/api/myservicetas/portalaccess/"+tokenId,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
  
        // console.log(response);
  
        if (response.status === 200) {
          setAuth((prev) => {
            // console.log(JSON.stringify(prev));
            // console.log(response.data); //it is accessToken
            return {
              ...prev,
              accessToken: response?.data?.accessToken,
              isLogin: true,
              isAblePrintOrRegister: response?.data?.ablePrintOrRegister,
              isBypassPayment: response?.data?.byPassPayment,
              isPnaIdVerified: response?.data?.pnaIdVerified,
            };
          });
          // console.log(from);
          navigate(response?.data?.redirectPage ? `/${response.data.redirectPage}` : "/", { replace: true });
        } else {
          // console.log("fail");
          setErrMsg(response.data);
        }
      } catch (err) {
        if (err.response.status === 401) {
          // setErrMsg("Unauthorized Access");
          setErrMsg("Session Expired");
        } else {
          setErrMsg(err.response.data);
        }
      }
  }

  useEffect(() => {
    if (!hasRun.current) {
        hasRun.current = true;
        callConnection();
    }
  }, []);

  return (
    <>
      <SubmitLoader isLoading={true}/>
    </>
  );
};

export default LoginPortalViaMyServiceTas;
